export default __webpack_public_path__ + "static/media/EliaBertolotti_0.5ETHM.33d81f7a.mp4";